import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import {
  ApolloClient,
  InMemoryCache,
  ApolloProvider,
  createHttpLink,
} from "@apollo/client";
import { ChakraProvider } from "@chakra-ui/react";
import { Auth } from "aws-amplify";
import { setContext } from "@apollo/client/link/context";
import * as Sentry from "@sentry/react";
import ErrorBoundary from "./components/ErrorBoundary";
import { Route, Routes, BrowserRouter as Router } from 'react-router-dom';
import App from "./App";
import ResetPassword from "./components/ResetPassword";
import VerifyUser from "./components/VerifyUser";
import { AlertProvider } from "./components/AlertProvider";
import { AppPage } from "./components/AppPage";
import { AuthProvider } from './services/AuthContext';
import { LoadScript } from "@react-google-maps/api";

// Initialize Sentry
Sentry.init({
  dsn: process.env.REACT_APP_WEBBOOKING_SENTRY_DSN,
  integrations: [new Sentry.BrowserProfilingIntegration()],
  tracesSampleRate: 0.2,
  tracePropagationTargets: [
    "localhost",
    /^https:\/\/api.staging.app.familydoctor.com.au/,
  ],
  replaysSessionSampleRate: 0.05,
  replaysOnErrorSampleRate: 1.0,
});

// Version ID for tracking current release
// console.log("Version:" + process.env.REACT_APP_VERSION);

const authLink = setContext(async (_, { headers }) => {
  try {
    //Try Cognito
    const session = await Auth.currentSession();
    // console.log({session})
    const token = session.getAccessToken().getJwtToken();
    if (token) {
      return {
        headers: {
          authorization: token ? `${token}` : "",
        },
      };
    }
  } catch (err) {
    //Try local storage
    const lastUser = localStorage.getItem(
      "CognitoIdentityServiceProvider." +
        process.env.REACT_APP_COGNITO_WEB_CLIENT_ID +
        ".lastAuthUser"
    );
    const token = localStorage.getItem(
      "CognitoIdentityServiceProvider." +
        process.env.REACT_APP_COGNITO_WEB_CLIENT_ID +
        "." +
        lastUser +
        ".accessToken"
    );
    if (token === undefined) return {};
    else
      return {
        headers: {
          authorization: token ? `${token}` : "",
        },
      };
  }
});

const httpLink = createHttpLink({
  uri: process.env.REACT_APP_BASE_URL,
});

const client = new ApolloClient({
  cache: new InMemoryCache(),
  link: authLink.concat(httpLink),
});

const WebBooking = () => {
  return (
    <ApolloProvider client={client}>
      <App />
    </ApolloProvider>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <LoadScript
    googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
    libraries={["places"]}
  >
    <React.StrictMode>
        <ApolloProvider client={client}>
            <ErrorBoundary>
                <AuthProvider>
                <ChakraProvider>
                    <AlertProvider>
                            <Router>
                                <Routes>
                                    <Route path="/app/:id" element={<AppPage />} />
                                    <Route path="/reset" element={<ResetPassword />} />
                                    <Route path="/verify" element={<VerifyUser />} />
                                    <Route path="*" element={<WebBooking />} />
                                </Routes>
                            </Router>                    
                    </AlertProvider>
                </ChakraProvider>
                </AuthProvider>
            </ErrorBoundary>
        </ApolloProvider>
    </React.StrictMode>
    </LoadScript>
);

reportWebVitals();
